// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"styles-module--logo-container--3avP-","logo":"styles-module--logo--16ihP"};